import React from 'react';

const KeywordsTab = ({ keywords, newKeyword, setNewKeyword, addKeyword, deleteKeyword }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-white mb-6">Content Moderation Keywords</h2>
      
      <form onSubmit={addKeyword} className="bg-gray-900 border border-gray-800 p-6 rounded-sm mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            type="text"
            value={newKeyword.word}
            onChange={(e) => setNewKeyword({ ...newKeyword, word: e.target.value })}
            placeholder="Keyword"
            required
            className="px-4 py-3 bg-gray-950 border border-gray-700 text-white rounded-sm"
          />
          <select
            value={newKeyword.action}
            onChange={(e) => setNewKeyword({ ...newKeyword, action: e.target.value })}
            className="px-4 py-3 bg-gray-950 border border-gray-700 text-white rounded-sm"
          >
            <option value="block">Block</option>
            <option value="moderate">Moderate</option>
          </select>
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-600 text-black font-bold py-3 px-6 rounded-sm uppercase tracking-wider"
          >
            Add Keyword
          </button>
        </div>
      </form>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {keywords.map((kw) => (
          <div key={kw.id} className="bg-gray-900 border border-gray-800 p-4 rounded-sm flex justify-between items-center">
            <div>
              <p className="text-white font-mono">{kw.word}</p>
              <p className={`text-xs font-mono ${kw.action === 'block' ? 'text-red-500' : 'text-yellow-500'}`}>
                {kw.action.toUpperCase()}
              </p>
            </div>
            <button
              onClick={() => deleteKeyword(kw.id)}
              className="text-red-500 hover:text-red-400"
            >
              ✕
            </button>
          </div>
        ))}
        
        {keywords.length === 0 && (
          <div className="col-span-full bg-gray-900 border border-gray-800 p-8 rounded-sm text-center">
            <p className="text-gray-500 font-mono">No keywords configured</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default KeywordsTab;
